import { Link, useLocation, useNavigate } from "react-router-dom";
import { LOGO_URL, NAV_IDS } from "../data/content";
import { useLang } from "../i18n/LanguageContext";

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useLang();

  const handleNav = (id) => {
    if (location.pathname !== "/") {
      navigate("/", { state: { scrollTo: id } });
      return;
    }
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <footer
      data-testid="site-footer"
      className="bg-navy-50/30 border-t border-navy/10 pt-16 pb-10"
    >
      <div className="container-vel grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5 flex flex-col">
          <div className="flex items-center gap-3">
            <img
              src={LOGO_URL}
              alt="Velocitas"
              className="h-12 w-12 object-contain"
            />
            <div className="flex flex-col leading-none">
              <span className="font-heading text-2xl text-navy tracking-tight font-medium">
                {t.nav.brand}
              </span>
              <span className="font-body text-[10px] tracking-[0.22em] uppercase text-ink-soft mt-1">
                {t.nav.brandSub}
              </span>
            </div>
          </div>
          <p className="mt-6 font-body text-sm text-ink-muted leading-relaxed max-w-sm">
            {t.footer.blurb}
          </p>
        </div>

        <div className="md:col-span-4">
          <div className="overline mb-4">{t.footer.navigateLabel}</div>
          <ul className="space-y-2">
            {NAV_IDS.map((link) => (
              <li key={link.id}>
                <button
                  data-testid={`footer-${link.testId}`}
                  onClick={() => handleNav(link.id)}
                  className="font-body text-sm text-ink-muted hover:text-coral transition-colors duration-300"
                >
                  {t.nav[link.labelKey]}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="overline mb-4">{t.footer.officeLabel}</div>
          <p className="font-body text-sm text-navy">{t.footer.officeText}</p>
          <p className="mt-2 font-body text-xs text-ink-soft">
            {t.footer.officeByAppt}
          </p>
        </div>
      </div>

      <div className="container-vel mt-10 border-t border-navy/10 pt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
        <p className="font-body text-xs text-ink-soft">
          © {new Date().getFullYear()} Velocitas. {t.footer.copyright}
        </p>
        <div className="flex items-center gap-5">
          <Link
            to="/privacy"
            data-testid="footer-privacy-link"
            className="font-body text-xs text-ink-soft hover:text-coral transition-colors duration-300"
          >
            {t.footer.privacy}
          </Link>
          <p className="font-body text-[10px] tracking-[0.22em] uppercase text-ink-soft">
            {t.footer.tagline}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
